export const toISOFormat = (dateTimeString, bar = false) => {
  const [date] = dateTimeString.split(' ');
  const [DD, MM, YYYY] = date.split('/');

  if (bar) return `${MM}/${DD}/${YYYY}`;
  return `${YYYY}-${MM}-${DD}`;
};
